// extracted by mini-css-extract-plugin
export default {"input":"input_input__23xip","required":"input_required__vJEgG"};